import type { SortDirection } from '@tanstack/react-table';
import React, { ReactElement } from 'react';
import Styles from './TableHeaderSortDirection.module.scss';

function TableHeaderSortDirection({ sortDirection }: Readonly<{ sortDirection: false | SortDirection }>): ReactElement {
    if (sortDirection === 'asc') {
        return (
            <div className={Styles.sortIcons}>
                <span className="material-symbols-outlined">north</span>
            </div>
        );
    }

    if (sortDirection === 'desc') {
        return (
            <div className={Styles.sortIcons}>
                <span className="material-symbols-outlined">south</span>
            </div>
        );
    }

    return (
        <div className={`${Styles.sortIcons} ${Styles.sortIconsUnsorted}`}>
            <span className="material-symbols-outlined">sort</span>
        </div>
    );
}

export default TableHeaderSortDirection;